import {ProductServiceTypeEnum} from '../../constants/product.constants';
import {TvShopEntertainmentPack} from '../tv-shop-entertainment-pack';

export interface CustomerProductHoldingProduct {
  products: CustomerProductHoldingProduct[],
  options: CustomerProductHoldingProduct[],
  servicetype: string[],
  specurl: string;
}

export class CustomerProductHoldingUtil {

  public static hasDTVAndInternet(customerProductHolding: CustomerProductHoldingProduct[]): boolean {
    return this.hasDTV(customerProductHolding) && this.hasInternet(customerProductHolding);
  }

  public static hasDTV(customerProductHolding: CustomerProductHoldingProduct[]): boolean {
    return customerProductHolding.some(
      (product: CustomerProductHoldingProduct) => {
        const bundleHasDTV = product.servicetype && product.servicetype.includes(ProductServiceTypeEnum.DTV);
        const childProductsHaveDTV = this.hasDTV(product.products);
        return bundleHasDTV || childProductsHaveDTV;
      }
    );
  }

  public static hasInternet(customerProductHolding: CustomerProductHoldingProduct[]): boolean {
    return customerProductHolding.some(
      (product: CustomerProductHoldingProduct) => {
        const bundleHasDTV = product.servicetype && product.servicetype.includes(ProductServiceTypeEnum.FIXED_INTERNET);
        const childProductsHaveDTV = this.hasInternet(product.products);
        return bundleHasDTV || childProductsHaveDTV;
      }
    );
  }

  static ownsTvShopEntertainmentPack(streamingService: TvShopEntertainmentPack, customerProductHolding: CustomerProductHoldingProduct[]): boolean {
    return customerProductHolding.some((product) => {
      const omapiId = this.getOmapiIdFromSpecUrl(product.specurl);
      if (omapiId === streamingService.omapiId) {
        return true;
      }
      return product.options.some((option) => {
        const optionOmapiId = this.getOmapiIdFromSpecUrl(option.specurl);
        return optionOmapiId === streamingService.omapiId;
      });
    });
  }

  private static getOmapiIdFromSpecUrl(specUrl: string): string {
    return specUrl.split('/').pop();
  }
}
